import { useTranslation } from "react-i18next";

import { usePaymentMode } from "@/hooks/usePaymentMode";

const labelKeys = {
  invoice: "user-account.tabs.billingRecipients",
  default: "user-account.tabs.paymentMethods",
} as const;

/** Invoice customers manage Rechnungsempfänger instead of a payment method. */
export const usePaymentsTabLabel = () => {
  const { t } = useTranslation("portal");
  const { isInvoice } = usePaymentMode();

  return t(labelKeys[isInvoice ? "invoice" : "default"]);
};
